import type { FC } from 'react'
import { components } from 'react-select'
import type { OptionProps } from 'react-select'
import Face from '@mui/icons-material/Face'
import AccessTime from '@mui/icons-material/AccessTime'
import { Box, Typography } from '@mui/material'
import Highlighter from 'react-highlight-words'
import { formatUserDateOfBirth } from '~/shared/lib/date'
import { formatPhoneNumber } from '~/shared/lib/displayText'
import { AccountTypeStatusRing } from '~/shared/ui'
import { personRowName } from '~/entities/person'
import { getSearchHighlights, type PersonSearchOption } from './PeopleSearchUtils'

const HIGHLIGHT_STYLE = { fontWeight: 'bold' }

// Options show patient data from both the recently-viewed list and search results.
const PatientSearchOption: FC<OptionProps<PersonSearchOption, false>> = props => {
  const isSearching = props?.selectProps?.inputValue?.length

  const phoneNumber = props.data.phone_number ?? ''
  const name = `${personRowName(props.data)}${props.data.request_auth_for_phi ? ' (VIP)' : ''}`
  let data = props.data.dob ? `${formatUserDateOfBirth(props.data.dob)} | ` : ''
  data = props.data.sex ? `${data}${props.data.sex} | ` : data
  data = `${data}${formatPhoneNumber(phoneNumber)} | ID: ${props.data.id}`

  let nameSearchHighlight: string[] = []
  let numberSearchHighlight: string[] = []
  if (isSearching) {
    ;[nameSearchHighlight, numberSearchHighlight] = getSearchHighlights(
      props.selectProps.inputValue,
      name,
      phoneNumber,
    )
  }

  const PatientIcon = isSearching ? Face : AccessTime

  return (
    <components.Option {...props}>
      <Box sx={{ display: 'flex', alignItems: 'center', '&:hover a': { transform: 'scaleX(1)' } }}>
        <AccountTypeStatusRing
          accountType={props.data.account_type}
          size={30}
          badgeSize={15}
          sx={{ mr: 1 }}
        >
          <PatientIcon />
        </AccountTypeStatusRing>
        <div>
          <Typography>
            <Highlighter
              highlightTag="span"
              highlightStyle={HIGHLIGHT_STYLE}
              searchWords={nameSearchHighlight}
              textToHighlight={name}
            />
          </Typography>
          <Typography sx={{ fontSize: '1.2rem' }}>
            <Highlighter
              highlightTag="span"
              highlightStyle={HIGHLIGHT_STYLE}
              searchWords={numberSearchHighlight}
              textToHighlight={data}
            />
          </Typography>
        </div>
      </Box>
    </components.Option>
  )
}

export default PatientSearchOption
